module.exports = {"attributes":{"width":"8px","height":"8px","viewBox":"0 0 8 8","version":"1.1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"},"content":"<g stroke=\"none\" stroke-width=\"1\">         <rect x=\"3\" y=\"0\" width=\"2\" height=\"8\"></rect>         <rect x=\"0\" y=\"3\" width=\"8\" height=\"2\"></rect>     </g>"}


//////////////////
// WEBPACK FOOTER
// ./client/components/Icon/images/plus.svg
// module id = 1434
// module chunks = 0